<template >
    <div v-if="!tutorialIntroShown">
        <p class="text-center  max-w-sm text-xl mb-2">Welcome to <b class="text-racing-stars-yellow">Racing Stars</b>.</p> 
        <p class="text-center  max-w-sm">Before we get started please take a few minutes to take our tutorial. <br>If you already know what your doing feel free to skip.</p>

        <button type="button" @click="$emit('update', (0))"
            class="mt-1 flex w-full justify-center rounded-md bg-gray-500 px-4 py-2 text-left text-sm font-medium text-gray-200 hover:text-gray-100 focus:outline-none focus-visible:ring focus-visible:ring-purple-500 focus-visible:ring-opacity-75">
            Skip Tutorial
        </button>

        <button type="button" v-on:click="(tutorialIntroShown = true)"
            class="mt-2 font-semibold w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm text-black bg-racing-stars-yellow hover:text-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-racing-stars-yellow">
            Begin Tutorial
        </button>
    </div>

    <div v-else>
        <div class="mb-1 text-base font-medium text-racing-stars-yellow">Step 1 of 14</div>
    <div class="w-full bg-gray-200 rounded-full h-2.5 mb-1 dark:bg-gray-700 ">
        <div class="bg-gradient-to-r from-racing-stars-yellow to-yellow-200 h-2.5 rounded-full"
            :style="{ 'width': 7.142857143 + '%' }"></div>
    </div>
    <p class="text-center  max-w-sm">The <b class="text-racing-stars-yellow">'Play'</b> section is where you will enter
        and manage your race meetings with us.</p>

    <button type="button" :v-model="tutorialStep" @click.stop="$emit('update', (tutorialStep += 1));"
        class="mt-2 font-semibold w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm text-black bg-racing-stars-yellow hover:text-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-racing-stars-yellow">
        Next step
    </button>
    </div>

</template>

<script>
import Popper from 'vue3-popper'
import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/vue'
import { ChevronUpIcon, ChevronDownIcon} from '@heroicons/vue/outline'

export default {
    props: {
        meeting: {
            type: Object,
            default: {}
        },
        tutorialStep: {
            type : Number,
        },
        tutorialIntroShown : {
            type : Boolean,
            default : false,
        },
    },
    components: {
        Disclosure,
        DisclosureButton,
        DisclosurePanel,
        Popper,
        ChevronDownIcon,
        ChevronUpIcon,
    },
}

</script>